import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

import { ClientDataRequestEvents, ContractModificationRequestEvents, EmailsEvents, RequestEvents } from './events';
import { DEFAULT_PAGE_SIZE } from '../../constants/commonConstants';
import { ENV_CONFIG } from 'src/app/core/injection.token';

type DynamicResponse<T> = app.models.DynamicResponse<T>;
type DynamicPaged<T> = app.models.DynamicResponse<app.models.PagedResult<T>>;

@Injectable()
export class EmailAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'email';

  public getEmails(emailXRequestTypes: app.models.EmailXRequestTypes) {
    const request = 'getEmails';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.postGet<app.models.DynamicResponse<app.models.Email[]>>(url, emailXRequestTypes);
  }

  public getEmailXRequestTypesByEmailId(emailId: string) {
    const request = 'getEmailXRequestTypesByEmailId';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, {
      emailId: emailId,
    });

    return this._apiService.get<app.models.DynamicResponse<app.models.EmailXRequestTypes>>(url);
  }

  public saveEmailXRequestTypes(requestBody: app.models.EmailXRequestTypes) {
    const request = 'saveEmailXRequestTypes';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = requestBody;
    const successEvents = [EmailsEvents.EmailXRequestTypesSaved];

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, body, successEvents);
  }

  public deleteEmail(emailId: string) {
    const request = 'deleteEmail';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const successEvents = [EmailsEvents.EmailDeleted];

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, { emailId: emailId }, successEvents);
  }
}
